/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */

import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import * as Yup from 'yup';
import {
  ArrowBack,
  CalendarTodayRounded,
  CloseRounded,
  EditRounded,
  RemoveCircleRounded,
  SearchRounded,
} from '@mui/icons-material';
import { toast } from 'react-toastify';
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputAdornment,
  SwipeableDrawer,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { ChromePicker } from 'react-color';
import dayjs from 'dayjs';

import { stringAvatar } from '../../../utils/avatarGenerator';
import {
  Board,
  BoardMember,
  ListaReuniaoComMesAno,
  getUsersByCompanyIdRequest,
  getFutureMeetingByBoardIdRequest,
  getPastMeetingByBoardIdRequest,
} from '../../../services/requests';
import {
  updateBoardRequest,
  archiveBoardRequest,
  getBoardByIdRequest,
  activeBoardRequest,
} from '../../../services/requests/boards/utils';

import {
  Card,
  Container,
  Div,
  Header,
  Page,
  SectionBoard,
  SectionHeaderDrawer,
  TabButton,
  TabSelection,
  Typography,
  Text,
  ContainerUsers,
} from './styles';

import { Input } from '../../../components/Input';
import { InfoCard } from '../../../components/InfoCard';

import useAuthStore from '../../../store/auth';
import useCompanyStore from '../../../store/companies';
import { getCurrentTimezone } from '../../../utils/dateHelpers';
import { LoadingBackdrop } from '../../../components/LoadingBackdrop';

export interface MemberToSelect extends BoardMember {
  selected: boolean;
}

export const BoardDetails = () => {
  const params = useParams();

  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [listaUsuarios, setListaUsuarios] = useState<MemberToSelect[]>([]);
  const [listaMembros, setListaMembros] = useState<BoardMember[] | undefined>(
    [],
  );
  const [searchForUsers, setSearchForUsers] = useState('');
  const [newBoardId, setNewBoardId] = useState('');
  const [colorBoard, setColorBoard] = useState('#230674');
  const [openColor, setOpenColor] = useState(false);
  const [statusMeeting, setStatusMeeting] = useState('futuras');
  const navigate = useNavigate();
  const [openDrawerBoard, setOpenDrawerBoard] = useState(false);
  const [boardSelected, setBoardSelected] = useState<Board>({} as Board);
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingBoard, setLoadingBoard] = useState(true);
  const [listUsersFiltered, setListUsersFiltered] = useState<MemberToSelect[]>(
    [],
  );
  const [openModalDesactiveBoard, setOpenModalDesactiveBoard] = useState(false);
  const [listagemReunioesFuturas, setListagemReunioesFuturas] = useState<
    ListaReuniaoComMesAno[]
  >([]);
  const [listagemReunioesPassadas, setListagemReunioesPassadas] = useState<
    ListaReuniaoComMesAno[]
  >([]);
  const [isAdminOnCompanyOrBoard, setIsAdminOnCompanyOrBoard] = useState(false);
  const [backdropLoading, setBackdropLoading] = useState({
    status: false,
    text: 'Carregando',
  });

  const userFiltered = boardSelected?.members?.find(u => u?.id === user?.id);

  useEffect(() => {
    if (user) {
      const userOnCompany = selectedCompany?.users?.find(
        (u: any) => u.id === user?.id,
      );
      const isAdminOnCompAndBoard =
        userOnCompany?.profile === 'UN1' ||
        userOnCompany?.profile === 'UN2' ||
        userFiltered?.profile === 'BMS1';

      setIsAdminOnCompanyOrBoard(isAdminOnCompAndBoard);
    }
  }, [user, selectedCompany, userFiltered]);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      title: Yup.string()
        .min(1, 'Mínimo 1 caracter')
        .max(50, 'Máximo 50 caracteres')
        .required('O título é obrigatório.'),
      description: Yup.string().nullable(),
    });
  }, []);
  const {
    control,
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const handleUserToInvite = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: MemberToSelect,
      idx: number,
      type: 'select' | 'profile',
    ) => {
      let listaUsuariosEditada = { ...usr };

      if (type === 'select') {
        listaUsuariosEditada.selected = !usr?.selected;
      }

      if (type === 'profile') {
        listaUsuariosEditada.profile =
          usr?.profile === 'BMS1' ? 'BMS2' : 'BMS1';
      }

      if (searchForUsers?.length > 0) {
        const listFilteredWhenSearching = listaUsuarios?.map(u => {
          if (u?.id === usr?.id) {
            setSearchForUsers('');
            return listaUsuariosEditada;
          }
          return u;
        });
        const usuariosMembros = listFilteredWhenSearching?.filter(
          u => u.selected,
        );
        setListaMembros([...usuariosMembros!]);
        setListaUsuarios(listFilteredWhenSearching);
        setListUsersFiltered(listFilteredWhenSearching);
      } else {
        listaUsuarios?.splice(idx, 1, listaUsuariosEditada);
        listUsersFiltered?.splice(idx, 1, listaUsuariosEditada);
        setListUsersFiltered([...listUsersFiltered!]);
        setListaUsuarios([...listaUsuarios!]);
        const usuariosMembros = listaUsuarios?.filter(u => u.selected);
        setListaMembros([...usuariosMembros!]);
      }
    },
    [listUsersFiltered, listaUsuarios, searchForUsers.length],
  );

  const handleArchiveBoard = useCallback(async () => {
    setOpenModalDesactiveBoard(false);
    if (isAdminOnCompanyOrBoard) {
      const boardId = boardSelected.id;
      try {
        setBackdropLoading({
          status: true,
          text: 'Arquivando board',
        });
        if (boardId) {
          const response = await archiveBoardRequest(
            boardId,
            selectedCompany?.id as string,
            user?.id as string,
          );

          if (response?.status === 200) {
            navigate('/home/boards');
          }
        }
      } catch (err) {
        console.log('Error => BoardDetails => handleArchiveBoard', err);
      } finally {
        setBackdropLoading({
          status: true,
          text: 'Carregando informações do board',
        });
      }
    } else {
      toast.warning('Você não tem permissão para arquivar este board');
    }
  }, [
    boardSelected.id,
    isAdminOnCompanyOrBoard,
    navigate,
    selectedCompany?.id,
    user?.id,
  ]);

  const handleActiveBoard = useCallback(
    async (board: Board) => {
      try {
        if (isAdminOnCompanyOrBoard) {
          try {
            setBackdropLoading({
              status: true,
              text: 'Ativando board',
            });
            const boardId = board?.id;

            const response = await activeBoardRequest(
              boardId,
              user?.id as string,
              selectedCompany?.id as string,
            );

            if (response?.status === 200) {
              navigate('/home/boards');
            }
          } catch (error) {
            console.log('Error => BoardDetails => handleArchiveBoard', error);
          } finally {
            setBackdropLoading({
              status: true,
              text: 'Arquivando board',
            });
          }
        } else {
          toast.warning('Você não tem permissão para arquivar este board');
        }
      } catch (err) {
        console.log(err);
      }
    },
    [isAdminOnCompanyOrBoard, navigate, selectedCompany?.id, user?.id],
  );

  const getBoardById = useCallback(async () => {
    try {
      setBackdropLoading({
        status: true,
        text: 'Carregando informações do board',
      });

      const idBoard = params?.id;

      const response = await getBoardByIdRequest(idBoard as string);

      if (response?.status === 200) {
        const board = response?.data;

        setValue('title', board?.title);
        setValue('description', board?.description);
        setColorBoard(board?.color as string);
        setListaMembros(board?.members as BoardMember[]);
        setNewBoardId(board?.id);

        setBoardSelected({ ...board });
        const responseUsers = await getUsersByCompanyIdRequest(
          selectedCompany?.id as string,
          searchForUsers,
          '',
          '100',
          '',
        );

        if (responseUsers?.data?.data?.length > 0) {
          const usuarios = responseUsers?.data?.data?.map((u: BoardMember) => ({
            ...u,
            profile: 'BMS2',
            selected: false,
          }));

          const membros = board?.members?.map((u: BoardMember) => ({
            ...u,
            selected: true,
          }));

          const usuariosFiltrados = _.differenceBy(
            usuarios as any,
            membros as any,
            'id',
          );

          const todosUsuarios = membros?.concat(usuariosFiltrados as any);

          setListaUsuarios(todosUsuarios as any);
        }
        setLoadingBoard(false);
      }
    } catch (error) {
      console.log('Error => Board Details => getBoardById', error);
    } finally {
      setBackdropLoading({
        status: false,
        text: 'Carregando informações do board',
      });
    }
  }, [params?.id, searchForUsers, selectedCompany?.id, setValue]);

  useEffect(() => {
    if (params?.id) {
      getBoardById();
    }
  }, [params]);

  useEffect(() => {
    const filterUser = listaUsuarios?.filter(users =>
      users.name.toUpperCase().includes(searchForUsers.toUpperCase()),
    );
    setListUsersFiltered(filterUser);
  }, [searchForUsers, openDrawerBoard]);

  const handleEditBoard = useCallback(
    async (formData: any) => {
      if (isAdminOnCompanyOrBoard) {
        setBackdropLoading({
          status: true,
          text: 'Editando informações do board',
        });

        try {
          const members = listaMembros?.map(m => ({
            id: m.id,
            name: m.name,
            email: m.email,
            profile: m.profile,
            status: m.status,
            avatar_url: m.avatar_url,
          }));

          const board = {
            title: formData.title,
            description: formData.description,
            color: colorBoard,
            members,
            company_id: selectedCompany?.id,
          };

          const response = await updateBoardRequest(
            board as any,
            boardSelected.id!,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (response?.status === 200) {
            const boardEditado = response?.data;

            setBoardSelected({ ...boardEditado });
            setOpenDrawerBoard(false);
            console.log(boardSelected);
          }
        } catch (error) {
          console.log('Error => Board Details => handleEditBoard', error);
        } finally {
          setBackdropLoading({
            status: false,
            text: 'Carregando informações do board',
          });
        }
      } else {
        toast.warning('Você não tem permissão para editar o board');
      }
    },
    [
      isAdminOnCompanyOrBoard,
      listaMembros,
      colorBoard,
      selectedCompany?.id,
      boardSelected,
      user?.id,
    ],
  );

  async function LoadFutureMeetings() {
    const response = await getFutureMeetingByBoardIdRequest(
      params?.id as string,
      user?.id as string,
    );

    setListagemReunioesFuturas(response?.data);
    // console.log('Reunioes Futuras', listagemReunioesFuturas);
  }

  useEffect(() => {
    if (selectedCompany && user && params?.id) {
      LoadFutureMeetings();
    }
  }, [user, selectedCompany, params]);

  async function LoadPastMeetings() {
    const response = await getPastMeetingByBoardIdRequest(
      params?.id as string,
      user?.id as string,
    );

    setListagemReunioesPassadas(response?.data);
    // console.log('Reunioes Passadas', listagemReunioesPassadas);
  }

  useEffect(() => {
    if (selectedCompany && user && params?.id) {
      LoadPastMeetings();
    }
  }, [user, selectedCompany, params]);

  const drawerBoard = () => (
    // <EditBoard setOpenDrawerBoard={setOpenDrawerBoard} />
    <Box
      sx={{
        width: '960px',
        height: '100%',
        padding: '20px',
        position: 'relative',
      }}
    >
      <SectionHeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerBoard(false)}
        />
        <Typography className="title">Editar Board</Typography>
      </SectionHeaderDrawer>
      <Box sx={{ marginTop: '20px' }}>
        <form onSubmit={handleSubmit(handleEditBoard)}>
          <Input
            name="title"
            label="Nome do Board"
            required
            control={control}
            type="text"
            fullWidth
            disabled={!isAdminOnCompanyOrBoard}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {openColor ? (
                    <div style={{ zIndex: '2' }}>
                      <div
                        style={{
                          position: 'fixed',
                          top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        }}
                        onClick={() => setOpenColor(false)}
                      />
                      <ChromePicker
                        color={colorBoard}
                        onChange={(e: any) => setColorBoard(e.hex)}
                      />
                    </div>
                  ) : (
                    <button
                      onClick={() => setOpenColor(true)}
                      disabled={!isAdminOnCompanyOrBoard}
                      style={{
                        backgroundColor: colorBoard,
                        width: '13px',
                        height: '13px',
                        borderRadius: '50%',
                        border: 0,
                      }}
                      type="button"
                      title=""
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />
          <Input
            name="description"
            disabled={!isAdminOnCompanyOrBoard}
            label="Descrição do Board"
            control={control}
            type="text"
            fullWidth
          />

          <Div>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              width="100%"
              justifyContent="space-between"
            >
              <Typography className="title-members">
                Gerencie os membros do board
              </Typography>
              <Typography className="title-select">
                {`Selecionados (${
                  listaUsuarios?.filter(u => u.selected === true)?.length
                })`}
              </Typography>
            </Box>
            <TextField
              fullWidth
              variant="filled"
              placeholder="Filtrar usuário..."
              value={searchForUsers}
              onChange={ev => setSearchForUsers(ev.target.value)}
              sx={{
                background: '#ffffff',
              }}
              InputProps={{
                endAdornment: <SearchRounded />,
              }}
            />
            {listUsersFiltered && listUsersFiltered?.length > 0 ? (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Typography className="header-table">Nome</Typography>
                <Typography className="header-table">Admin</Typography>
              </Box>
            ) : (
              <Box mt="8vh">
                <InfoCard title="Nenhum usuário encontrado" type="info" />
              </Box>
            )}
          </Div>
          {listUsersFiltered &&
            listUsersFiltered?.length > 0 &&
            (loadingUsers ? (
              <Box
                mt="8vh"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Box>
            ) : (
              <Box>
                <ContainerUsers>
                  <Table sx={{ width: '100%' }} aria-labelledby="tableTitle">
                    <TableBody>
                      {listUsersFiltered?.map((row, index) => {
                        // const isItemSelected = isSelected(row.name);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return isAdminOnCompanyOrBoard ? (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={row.selected}
                            tabIndex={-1}
                            key={row.id}
                            selected={row.selected}
                            sx={{ cursor: 'pointer' }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={row.selected}
                                sx={{ padding: '0' }}
                                onClick={event =>
                                  handleUserToInvite(
                                    event,
                                    row.name,
                                    row,
                                    index,
                                    'select',
                                  )
                                }
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                              />
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              sx={{ padding: '10px' }}
                              onClick={event =>
                                handleUserToInvite(
                                  event,
                                  row.name,
                                  row,
                                  index,
                                  'select',
                                )
                              }
                            >
                              <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                gap="20px"
                              >
                                {row?.avatar_url ? (
                                  <Avatar sx={{ width: '40px' }}>
                                    <img
                                      src={row?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(row.name!)}
                                    sx={{ width: '40px' }}
                                  />
                                )}
                                <Text fontSize="15px" fontWeight="600">
                                  {row.name}
                                </Text>
                              </Box>
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              sx={{ padding: '0', width: '1px' }}
                            >
                              {row.selected ? (
                                <Switch
                                  {...label}
                                  checked={row.profile === 'BMS1'}
                                  sx={{ paddingRight: '10px' }}
                                  onClick={event =>
                                    handleUserToInvite(
                                      event,
                                      row.name,
                                      row,
                                      index,
                                      'profile',
                                    )
                                  }
                                />
                              ) : (
                                <Switch
                                  {...label}
                                  sx={{ paddingRight: '10px' }}
                                  disabled
                                  onClick={event =>
                                    handleUserToInvite(
                                      event,
                                      row.name,
                                      row,
                                      index,
                                      'profile',
                                    )
                                  }
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={row.selected}
                            tabIndex={-1}
                            key={row.name}
                            selected={row.selected}
                            sx={{ cursor: 'not-allowed' }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={row.selected}
                                sx={{ padding: '0' }}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                              />
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              sx={{ padding: '10px' }}
                            >
                              <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                gap="20px"
                              >
                                {row?.avatar_url ? (
                                  <Avatar sx={{ width: '40px' }}>
                                    <img
                                      src={row?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(row.name!)}
                                    sx={{ width: '40px' }}
                                  />
                                )}
                                <Text fontSize="15px" fontWeight="600">
                                  {row.name}
                                </Text>
                              </Box>
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              sx={{ padding: '0', width: '1px' }}
                            >
                              {row.selected ? (
                                <Switch
                                  {...label}
                                  checked={row.profile === 'BMS1'}
                                  sx={{ paddingRight: '10px' }}
                                />
                              ) : (
                                <Switch
                                  {...label}
                                  sx={{ paddingRight: '10px' }}
                                  disabled
                                  onClick={event =>
                                    handleUserToInvite(
                                      event,
                                      row.name,
                                      row,
                                      index,
                                      'profile',
                                    )
                                  }
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </ContainerUsers>
                {/* <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={listaUsuarios.length}
            labelRowsPerPage="Linhas por página"
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}
              </Box>
            ))}

          {isAdminOnCompanyOrBoard ? (
            <Button
              variant="contained"
              color="success"
              type="submit"
              disabled={isSubmitting}
              sx={{
                color: '#ffffff',
                position: 'absolute',
                fontSize: '15px',
                fontWeight: '500',
                right: '20px',
                bottom: '20px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '6px 16px 6px 12px',
                gap: '8px',
                width: '202px',
                height: '40px',
                borderRadius: '4px',
              }}
            >
              Salvar Alterações
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              type="submit"
              disabled
              sx={{
                color: '#ffffff',
                position: 'absolute',
                fontSize: '15px',
                fontWeight: '500',
                right: '20px',
                bottom: '20px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '6px 16px 6px 12px',
                gap: '8px',
                width: '202px',
                height: '40px',
                borderRadius: '4px',
              }}
            >
              Salvar Alterações
            </Button>
          )}
        </form>
      </Box>
    </Box>
  );

  return (
    <Container>
      {backdropLoading.status && (
        <LoadingBackdrop
          text={backdropLoading.text}
          component=""
          loading={backdropLoading.status}
        />
      )}

      <>
        <Header>
          <Button
            className="btn-back"
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            <ArrowBack /> Voltar
          </Button>
        </Header>
        <Page>
          <SectionBoard justifyContent="space-between">
            <>
              <Div
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                }}
              >
                <Typography
                  className="title-board"
                  sx={{
                    color:
                      boardSelected.status === 'BS1' ? '#000000' : '#d62237',
                  }}
                >
                  {boardSelected?.title}
                </Typography>
                <Typography
                  className="text-board"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    alignItems: 'center',
                  }}
                >
                  <CalendarTodayRounded /> Cadastrado em:{' '}
                  {dayjs(boardSelected?.created_at || new Date()).format(
                    'D/M/YYYY',
                  )}{' '}
                </Typography>
                <Box sx={{ marginTop: '20px' }}>
                  <Typography className="text-board">
                    Admin:
                    <AvatarGroup
                      max={10}
                      sx={{
                        marginLeft: '42px',
                      }}
                    >
                      {boardSelected?.members?.map(
                        b =>
                          b.profile === 'BMS1' && (
                            <Tooltip title={b.name} arrow>
                              {b?.avatar_url ? (
                                <Avatar sx={{ width: '40px' }}>
                                  <img
                                    src={b?.avatar_url as string}
                                    alt="Foto de perfil"
                                    style={{ width: '100%' }}
                                  />
                                </Avatar>
                              ) : (
                                <Avatar
                                  {...stringAvatar(b.name!)}
                                  sx={{ width: '40px' }}
                                />
                              )}
                            </Tooltip>
                          ),
                      )}
                    </AvatarGroup>
                  </Typography>
                </Box>
                <Box>
                  <Typography className="text-board">
                    Membros:
                    <AvatarGroup
                      max={10}
                      sx={{
                        marginLeft: '22px',
                      }}
                    >
                      {boardSelected?.members?.map(
                        b =>
                          b.profile === 'BMS2' && (
                            <Tooltip title={b.name} arrow>
                              {b?.avatar_url ? (
                                <Avatar sx={{ width: '40px' }}>
                                  <img
                                    src={b?.avatar_url as string}
                                    alt="Foto de perfil"
                                    style={{ width: '100%' }}
                                  />
                                </Avatar>
                              ) : (
                                <Avatar
                                  {...stringAvatar(b.name!)}
                                  sx={{ width: '40px' }}
                                />
                              )}
                            </Tooltip>
                          ),
                      )}
                    </AvatarGroup>
                  </Typography>
                </Box>
              </Div>
              <Div
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <React.Fragment key="right">
                  {boardSelected.status === 'BS1' && (
                    <Button
                      variant="contained"
                      onClick={() => setOpenDrawerBoard(true)}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '6px 16px 6px 12px',
                        gap: '8px',
                        width: '202px',
                        height: '40px',
                        borderRadius: '4px',
                      }}
                    >
                      <EditRounded /> Editar Dados
                    </Button>
                  )}
                  <SwipeableDrawer
                    className="drawer"
                    anchor="right"
                    onClose={() => setOpenDrawerBoard(false)}
                    onOpen={() => setOpenDrawerBoard(true)}
                    open={openDrawerBoard}
                    ModalProps={{
                      keepMounted: true,
                    }}
                  >
                    {drawerBoard()}
                  </SwipeableDrawer>
                </React.Fragment>

                {isAdminOnCompanyOrBoard &&
                  userFiltered?.profile === 'BMS1' && (
                    <Button
                      variant={
                        boardSelected.status === 'BS1'
                          ? 'outlined'
                          : 'contained'
                      }
                      color="error"
                      onClick={() => setOpenModalDesactiveBoard(true)}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '6px 16px 6px 12px',
                        gap: '8px',
                        width: '202px',
                        height: '40px',
                        borderRadius: '4px',
                      }}
                    >
                      <RemoveCircleRounded />
                      {boardSelected.status === 'BS1'
                        ? 'Arquivar'
                        : 'Reativar Board'}
                    </Button>
                  )}
                <Dialog
                  open={openModalDesactiveBoard}
                  onClose={() => setOpenModalDesactiveBoard(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  id="dialog-main"
                >
                  <DialogTitle id="alert-dialog-title" sx={{ width: '560px' }}>
                    {boardSelected.status === 'BS1'
                      ? 'Arquivar Board'
                      : 'Recuperar Board'}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {boardSelected.status === 'BS1'
                        ? 'Deseja realmente arquivar este board?'
                        : 'Deseja realmente recuperar este board?'}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions sx={{ padding: '20px' }}>
                    <Button
                      onClick={() => setOpenModalDesactiveBoard(false)}
                      variant="text"
                      sx={{ color: '#9E9E9E' }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={
                        boardSelected.status === 'BS1'
                          ? () => handleArchiveBoard()
                          : () => handleActiveBoard(boardSelected)
                      }
                      autoFocus
                      color="error"
                      variant="contained"
                    >
                      Confirmar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Div>
            </>
          </SectionBoard>
          <Box width="100%" display="flex" flexDirection="row" gap="20px">
            <SectionBoard width="100%" flexDirection="column" maxHeight="50vh">
              <TabSelection>
                <TabButton
                  active={statusMeeting === 'futuras'}
                  onClick={() => setStatusMeeting('futuras')}
                >
                  Reuniões Futuras
                </TabButton>
                <TabButton
                  active={statusMeeting === 'passadas'}
                  onClick={() => setStatusMeeting('passadas')}
                >
                  Reuniões passadas
                </TabButton>
              </TabSelection>
              <Box width="100%" display="flex" flexDirection="column">
                {statusMeeting === 'futuras' ? (
                  listagemReunioesFuturas?.length > 0 ? (
                    listagemReunioesFuturas?.map(element =>
                      element.meetings.map(reuniao => (
                        <Card
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          gap="10px"
                        >
                          <Div
                            display="flex"
                            flexDirection="column"
                            gap="10px"
                            justifyContent="center"
                            alignItems="center"
                            className="meeting-data"
                          >
                            <Typography className="data">
                              {dayjs(reuniao.start_at).format('DD/MM')}
                            </Typography>
                            <Typography className="duration">
                              {`${dayjs(reuniao?.start_at)
                                .tz(getCurrentTimezone(), true)
                                .format('HH:mm')} - ${dayjs(reuniao?.start_at)
                                .add(reuniao?.duration, 'minutes')
                                .tz(getCurrentTimezone(), true)
                                .format('HH:mm')}`}
                            </Typography>
                          </Div>
                          <Div
                            display="flex"
                            flexDirection="column"
                            padding="0 16px"
                            gap="5px"
                          >
                            {boardSelected.status === 'BS1' && (
                              <Box>
                                {reuniao.status === 'MS1' && (
                                  <Typography
                                    className="status"
                                    sx={{
                                      background: '#BDBDBD',
                                      fontSize: '14px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Pautas a definir
                                  </Typography>
                                )}
                                {reuniao.status === 'MS2' && (
                                  <Typography
                                    className="status"
                                    sx={{
                                      background: '#160B8C',
                                      whiteSpace: 'nowrap',
                                      fontSize: '14px',
                                    }}
                                  >
                                    Pautas definidas
                                  </Typography>
                                )}
                                {reuniao.status === 'MS3' && (
                                  <Typography
                                    className="status"
                                    sx={{
                                      background: '#BDBDBD',
                                      fontSize: '14px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Pendente de ata
                                  </Typography>
                                )}
                                {reuniao.status === 'MS4' && (
                                  <Typography
                                    className="status"
                                    sx={{
                                      background: '#FFB547',
                                      fontSize: '14px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Ata inserida
                                  </Typography>
                                )}
                                {reuniao.status === 'MS5' && (
                                  <Typography
                                    className="status"
                                    sx={{
                                      background: '#4CAF50',
                                      fontSize: '14px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Ata assinada
                                  </Typography>
                                )}
                              </Box>
                            )}

                            <Typography className="title">
                              {reuniao.title}
                            </Typography>
                          </Div>
                        </Card>
                      )),
                    )
                  ) : (
                    <Box width="100%" mt="50px">
                      <InfoCard
                        title="Nenhuma reunião futura vinculada ao Board"
                        type="info"
                      />
                    </Box>
                  )
                ) : listagemReunioesPassadas?.length > 0 ? (
                  listagemReunioesPassadas?.map(e =>
                    e.meetings.map(reuniao => (
                      <Card
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        gap="10px"
                      >
                        <Div
                          display="flex"
                          flexDirection="column"
                          gap="10px"
                          justifyContent="center"
                          alignItems="center"
                          className="meeting-data"
                        >
                          <Typography className="data">
                            {dayjs(reuniao.start_at).format('DD/MM')}
                          </Typography>
                          <Typography className="duration">
                            {`${dayjs(reuniao?.start_at)
                              .tz(getCurrentTimezone(), true)
                              .format('HH:mm')} - ${dayjs(reuniao?.start_at)
                              .add(reuniao?.duration, 'minutes')
                              .tz(getCurrentTimezone(), true)
                              .format('HH:mm')}`}
                          </Typography>
                        </Div>
                        <Div
                          display="flex"
                          flexDirection="column"
                          padding="0 16px"
                          gap="5px"
                        >
                          {boardSelected.status === 'BS1' && (
                            <Box>
                              {reuniao.status === 'MS1' && (
                                <Typography
                                  className="status"
                                  sx={{
                                    background: '#BDBDBD',
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Pautas a definir
                                </Typography>
                              )}
                              {reuniao.status === 'MS2' && (
                                <Typography
                                  className="status"
                                  sx={{
                                    background: '#160B8C',
                                    whiteSpace: 'nowrap',
                                    fontSize: '14px',
                                  }}
                                >
                                  Pautas definidas
                                </Typography>
                              )}
                              {reuniao.status === 'MS3' && (
                                <Typography
                                  className="status"
                                  sx={{
                                    background: '#BDBDBD',
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Pendente de ata
                                </Typography>
                              )}
                              {reuniao.status === 'MS4' && (
                                <Typography
                                  className="status"
                                  sx={{
                                    background: '#FFB547',
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Ata inserida
                                </Typography>
                              )}
                              {reuniao.status === 'MS5' && (
                                <Typography
                                  className="status"
                                  sx={{
                                    background: '#4CAF50',
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Ata assinada
                                </Typography>
                              )}
                            </Box>
                          )}
                          <Typography className="title">
                            {reuniao.title}
                          </Typography>
                        </Div>
                      </Card>
                    )),
                  )
                ) : (
                  <Box width="100%" mt="50px">
                    <InfoCard
                      title="Nenhuma reunião passada vinculada ao Board"
                      type="info"
                    />
                  </Box>
                )}
              </Box>
            </SectionBoard>
          </Box>
        </Page>
      </>
    </Container>
  );
};
